var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.appIsReady)?_c('div',{staticClass:"app"},[_c('TemplateDefault')],1):_vm._e(),(_vm.modalBoxComponent)?[_c('ModalBox',[_c(_vm.modalBoxComponent,{tag:"component"})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }